"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocalizedErrorHandler = getLocalizedErrorHandler;
const types_1 = require("../types");
function getLocalizedErrorHandler(getTranslate, namespace) {
    return (error, request, response, next) => {
        if (!error) {
            next();
            return;
        }
        if (error instanceof types_1.LocalizedError) {
            const localizedError = error;
            response.status(localizedError.status).json({
                message: localizedError.message,
            });
            return;
        }
        else if (error instanceof types_1.LocalizableError) {
            const localizableError = error;
            const translate = getTranslate(request, namespace);
            const translatedMessage = translate(error.message);
            response.status(localizableError.status).json({
                message: translatedMessage,
            });
            return;
        }
        next();
    };
}
